<ppl-dialog
  title="Change Password"
  i18n-title="@@Change_Password"
  width="460px"
  [loading]="loading$ | async"
  (action)="onSave()"
  (cancel)="onCancel()"
  [formGroup]="form">
  <div class="content">
    <ppl-form-row>
      <ppl-form-column>
        <ppl-input-container
          label="Enter Current password"
          i18n-label="@@Enter_Current_password"
          pplFormControlName="currentPassword">
          <input
            pplInput
            type="password"
            name="current_password"
            autocomplete="current-password"
            formControlName="currentPassword" />
        </ppl-input-container>
      </ppl-form-column>
    </ppl-form-row>

    <ppl-form-row>
      <ppl-form-column>
        <ppl-input-container
          label="Enter New Password"
          i18n-label="@@Enter_New_Password"
          pplFormControlName="password1">
          <input
            pplInput
            type="password"
            name="password1"
            autocomplete="new-password"
            formControlName="password1" />
        </ppl-input-container>
      </ppl-form-column>
    </ppl-form-row>

    <ppl-form-row>
      <ppl-form-column>
        <ppl-input-container
          label="Confirm password"
          i18n-label="@@Confirm_password"
          pplFormControlName="password2">
          <input
            pplInput
            type="password"
            name="password2"
            autocomplete="new-password"
            formControlName="password2" />
        </ppl-input-container>
      </ppl-form-column>
    </ppl-form-row>
  </div>
</ppl-dialog>
